import React from "react";
import images from "../../../utils/images";
import Button from "../buttons/Button";
import styles from "../NoDataFound/NoDataFound.module.css";

const NoDataFound = ({
  title = "No Data Found",
  description,
  buttonText,
  onButtonClick,
}) => {
  return (
    <div className={styles.noDataContainer}>
      <img src={images.notDataFound} alt="No data found" />
      <h3>{title}</h3>
      {description && <p>{description}</p>}
      {buttonText && onButtonClick && (
        <Button onClick={onButtonClick}>{buttonText}</Button>
      )}
    </div>
  );
};

export default NoDataFound;
